import { render, staticRenderFns } from "./gouke.vue?vue&type=template&id=44c85543&scoped=true"
import script from "./gouke.vue?vue&type=script&lang=js"
export * from "./gouke.vue?vue&type=script&lang=js"
import style0 from "./gouke.vue?vue&type=style&index=0&id=44c85543&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c85543",
  null
  
)

export default component.exports